import { render } from "./OperationMergeDialog.vue?vue&type=template&id=39385793&scoped=true"
import script from "./OperationMergeDialog.vue?vue&type=script&lang=js"
export * from "./OperationMergeDialog.vue?vue&type=script&lang=js"

import "./OperationMergeDialog.vue?vue&type=style&index=0&id=39385793&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39385793"]])

export default __exports__